import { __assign, __read } from "tslib";
import IconButtonControl from '@office-start/icon-button-control';
import { QuickAccessIcon } from '@office-start/quick-access-icon';
import classNames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';
import { useLayoutContext } from '../hooks/useLayoutContext';
import { LayoutOption } from '../LayoutOption';
import styles from '../LayoutSwitchControl.module.scss';
export var LayoutButton = function (_a) {
    var _b;
    var layoutPreference = _a.layoutPreference, title = _a.title, onSelectLayout = _a.onSelectLayout;
    var _c = useLayoutContext(), currentLayout = _c.currentLayout, setCurrentLayout = _c.setCurrentLayout;
    var _d = __read(useState(false), 2), isHovered = _d[0], setIsHovered = _d[1];
    var wrappedOnClick = useCallback(function () {
        if (onSelectLayout && currentLayout != layoutPreference) {
            onSelectLayout(layoutPreference);
        }
        if (setCurrentLayout) {
            setCurrentLayout(layoutPreference);
        }
    }, [currentLayout, layoutPreference, onSelectLayout, setCurrentLayout]);
    var containerEvents = useMemo(function () {
        return {
            onMouseOver: function () { return setIsHovered(true); },
            onMouseLeave: function () { return setIsHovered(false); },
        };
    }, []);
    var iconControl = useMemo(function () {
        var iconNameDefault = layoutPreference === LayoutOption.List ? 'List' : 'Grid';
        var active = currentLayout === layoutPreference || isHovered ? 'Active' : '';
        var iconName = "".concat(iconNameDefault).concat(active);
        return React.createElement(QuickAccessIcon, { iconName: iconName });
    }, [currentLayout, layoutPreference, isHovered]);
    return (React.createElement("div", __assign({ className: styles['button-wrapper'] }, containerEvents),
        React.createElement(IconButtonControl, { iconClass: classNames(styles['layout-switch-icon'], (_b = {},
                _b[styles['layout-switch-icon--active']] = currentLayout === layoutPreference,
                _b)), onClick: wrappedOnClick, iconControl: iconControl, ariaLabel: title, ariaRole: "button", ariaPressedState: currentLayout === layoutPreference, title: title, tabIndex: 0 })));
};
//# sourceMappingURL=LayoutButton.js.map